import { render } from "./TasterPack.vue?vue&type=template&id=1548eac8&scoped=true"
import script from "./TasterPack.vue?vue&type=script&lang=js"
export * from "./TasterPack.vue?vue&type=script&lang=js"

import "./TasterPack.vue?vue&type=style&index=0&id=1548eac8&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1548eac8"]])

export default __exports__